import React, { Component } from "react";
import { connect } from "react-redux";
import { Route, Switch, Link } from "react-router-dom";
import { AuthActions } from "../../modules/auth";
import Box from "../../components/Box";
import Chart from "../../components/Chart";
import ListData from "../../components/ListData";
import ListSalesData from "../../components/ListSalesData";
import DatePicker from "../../components/DatePicker";
import MultiSelect from "../../components/MultiSelect";
import LoadingModal from "../../components/LoadingModal";
import TableData from "../../components/TableData";
import "./styles.css";
import { AnalyticsActions, AnalyticsSelectors } from "../../modules/analytics";
import { AuthSelectors } from "../../modules/auth";
import {
  Menu,
  Container,
  Dropdown,
  Header,
  Grid,
  Sidebar,
  Segment,
  Divider,
  Label,
  Icon,
} from "semantic-ui-react";

import moment from "moment";

const { authOnLogout, authOnInit } = AuthActions;
const displayValue = (value, displayCurrency = "", percentage = "") => {
  if (value == undefined || value <= 0 || value == "No Sales") {
    return "-";
  }

  return displayCurrency + " " + value + " " + percentage;
};

const { loadInitialAnalyticsState } = AnalyticsActions;
const { getSelectorAnalytics } = AnalyticsSelectors;
const { getSelectorAuth } = AuthSelectors;

const options = [
  {
    value: "all",
    text: "Location",
    style: {
      backgroundColor: "none",
      color: "rgb(102, 104, 116)",
      fontSize: 14,
      fontWeight: 300,
    },
  },
  {
    value: "locone",
    text: "Location One",
    style: {
      backgroundColor: "none",
      color: "rgb(102, 104, 116)",
      fontSize: 14,
      fontWeight: 300,
    },
  },
  {
    value: "loctwo",
    text: "Location Two",
    style: {
      backgroundColor: "none",
      color: "rgb(102, 104, 116)",
      fontSize: 14,
      fontWeight: 300,
    },
  },
];

class Home extends Component {
  componentWillMount() {
    // this.props.authOnInit();
  }

  componentDidMount() {
    const { start_date, end_date } = this.props.filters.selectedDate;
    this.props.loadInitialAnalyticsState(start_date, end_date);
  }

  onLogout() {
    this.props.authOnLogout();
  }
  constructor(props) {
    super(props);

    this.state = { value: "all" };
  }

  reset() {
    this.setState({ value: undefined });
  }

  setProducts() {
    this.setState({ value: "products" });
  }

  setValue(e, data) {
    this.setState({ value: data.value });
  }

  render() {
    const {
      net_sales,
      gross_margin,
      total_orders,
      locations,
      top_items_by_sales,
      lowest_items_by_sales,
      sales_by_store,
      sales_by_category_chart,
      sales_by_day,
      sales_by_hour_chart,
      all_locations_insights,
      avg_order_size,
      avg_order_value,
      top_basket_category,
      sales_by_category,
      sales_by_sub_category,
      currency,
      auth,
    } = this.props;
    // String manipulation //

    //const { value } = this.state;
    // console.log("this.props: ", this.props);
    //console.log(this.props.net_sales.value);
    //this.props.net_sales.value = this.props.net_sales.value.replace("Rs." ,"USD") ;
    if (this.props.net_sales.value != undefined) {
      this.props.net_sales.value = this.props.net_sales.value.replace(
        "Rs.",
        ""
      );
      this.props.avg_sales.value = this.props.avg_sales.value.replace(
        "Rs.",
        ""
      );
      console.log("currrr ", this.props.currency);
    }
    console.clear();

    ////////////////////////

    const gross_margin_value = {
      header: gross_margin.header,
      value: gross_margin.data_one.value,
    };

    const totalOnline = {
      header: "Online Stores",
      value: locations.length,
    };

    const barChartTemplate = {
      lang: {
        thousandsSep: ",",
      },
      chart: {
        backgroundColor: "none",
        marginLeft: 45,
        height: 382,
        fontFamily: "Roboto",
        fontWeight: 400,
        spacingTop: 10,
        type: "line",
        style: {
          paddingBottom: 10,
          fontSize: 16,
        },
      },
      title: {
        useHTML: true,
        style: {
          color: "#414042",
          fontSize: 16,
          fontWeight: 400,
          fontFamily: "Roboto",
        },
        text: null,
        align: "left",
        x: -5,
        y: 5,
      },
      xAxis: {
        categories: [],
        labels: {
          style: {
            fontSize: "8px",
          },
        },
      },
      yAxis: [
        {
          title: {
            text: null,
          },
        },
      ],
      legend: {
        itemStyle: {
          fontWeight: "400",
          fontSize: "13px",
          fontFamily: "Roboto",
          color: "#414042",
        },
      },
      labels: {
        items: [],
      },
      series: [],
      credits: {
        enabled: false,
      },
    };

    const pieChartTemplate = {
      chart: {
        backgroundColor: "none",
        plotBackgroundColor: null,
        plotBorderWidth: 0,
        plotShadow: false,
        verticalAlign: "top",
        height: 280,
        color: "#414042",
      },
      title: {
        text: null,
        align: "center",
        verticalAlign: "middle",
        color: "#414042",
        y: 8,
        style: {
          color: "#666874",
          fontSize: 14,
          fontWeight: 400,
          fontFamily: "Roboto",
        },
      },
      tooltip: {
        pointFormat: "{series.name}: <b>{point.percentage:.1f}%</b>",
        style: {
          fontWeight: 200,
          fontSize: 12,
        },
      },
      plotOptions: {
        pie: {
          colors: [
            "#ed561b ",
            "#f58233 ",
            "#ffb91a ",
            "#fff263 ",
            "#3050d6 ",
            "#2f7ed8 ",
            "#4897e5 ",
            "#409b23 ",
            "#50b432 ",
            "#97bf2b ",
            "#b8d649 ",
          ],
          dataLabels: {
            enabled: false,
            distance: 100,
            color: "#414042",
            style: {
              fontWeight: "400",
              color: "#414042",
            },
          },
          center: ["50%", "55%"],
        },
      },
      series: [],
      credits: {
        enabled: false,
      },
    };
    const MAXIMUM_ALLOWED_ELEMENTS = 50;
    const salesByStore = JSON.parse(JSON.stringify(barChartTemplate));
    // salesByStore['title']['text'] = 'SALES BY STORE';
    if (sales_by_store["categories"]) {
      salesByStore["xAxis"]["categories"] = sales_by_store["categories"].slice(
        0,
        MAXIMUM_ALLOWED_ELEMENTS
      );
    }
    for (var index in sales_by_store["series"]) {
      let values = sales_by_store["series"][index]["data"].slice(
        0,
        MAXIMUM_ALLOWED_ELEMENTS
      );
      sales_by_store["series"][index]["data"] = values;
      if (sales_by_store["series"][index]["name"] === "Orders") {
        sales_by_store["series"][index]["visible"] = false;
      }
    }

    salesByStore["series"] = sales_by_store["series"].filter((item) =>
      ["Sales", "Orders"].includes(item.name)
    );

    const secondary_yAxis = {
      gridLineWidth: 0,
      title: {
        text: null,
      },
      opposite: true,
    };
    salesByStore["yAxis"].push(secondary_yAxis);

    const salesbyDay = JSON.parse(JSON.stringify(barChartTemplate));
    // salesbyDay['title']['text'] = 'SALES BY DAY';
    salesbyDay["xAxis"]["categories"] = sales_by_day["categories"];
    salesbyDay["series"] = sales_by_day["series"];

    const salesbyHour = JSON.parse(JSON.stringify(barChartTemplate));
    // salesbyHour['title']['text'] = 'SALES BY HOUR';
    salesbyHour["xAxis"]["categories"] = sales_by_hour_chart["categories"];
    salesbyHour["series"] = sales_by_hour_chart["series"];

    let salesByCategory = { ...pieChartTemplate };
    salesByCategory["title"]["text"] = sales_by_category_chart["title"]["text"];
    salesByCategory["series"] = sales_by_category_chart["series"];

    let marginBystore = { data: { values: [] }, header: "MARGIN BY STORE" };
    let salesByStoreInsights = {
      data: {
        headers:
          auth.filters && auth.filters.user_type == "shell_head_office"
            ? [
                "Ship To Number",
                "Tier",
                "Site Name",
                "Region",
                "Territory",
                "Store",
                "Net Sales",
                "Gross Margin (Rs.)",
                "Gross Margin (%)",
                "Total Orders",
                "Gross Sales",
                "Top Basket Category",
                "Refunds",
                "Refunds Number",
                "Discounts",
                "Total COGS",
                "Avg Order Size",
                "Avg Order Value",
                "Void Number",
                "Void",
              ]
            : [
                "Store",
                "Net Sales",
                "Gross Margin (Rs.)",
                "Gross Margin (%)",
                "Total Orders",
                "Gross Sales",
                "Top Basket Category",
                "Refunds",
                "Refunds Number",
                "Discounts",
                "Total COGS",
                "Avg Order Size",
                "Avg Order Value",
                "Void Number",
                "Void",
              ],
        values: [],
      },
      header: "SALES BY STORE",
    };

    all_locations_insights.map((item, index) => {
      let value = {
        category: { value: item.name },
        amt_cur: { value: item.gross_margin.data_two.value },
      };
      marginBystore["data"]["values"].push(value);
    });
    all_locations_insights.map((item, index) => {
      let value = {
        name: item.name,
        net_sales_original: item.net_sales.original_value,
        values:
          auth.filters && auth.filters.user_type == "shell_head_office"
            ? [
                item.ship_to_num,
                item.tier,
                item.retail_site_name,
                item.region_name,
                item.territory_name,
                item.name,
                item.net_sales.value,
                item.gross_margin.data_one.value,
                item.gross_margin.data_two.value,
                item.total_orders.value,
                item.gross_sales.value,
                item.top_basket_category.value,
                item.refunds.value,
                item.refunds_number.value,
                item.discounts.value,
                item.total_cogs.value,
                item.avg_order_size.value,
                item.avg_order_value.value,
                item.void_number.value,
                item.void.value,
              ]
            : [
                item.name,
                item.net_sales.value,
                item.gross_margin.data_one.value,
                item.gross_margin.data_two.value,
                item.total_orders.value,
                item.gross_sales.value,
                item.top_basket_category.value,
                item.refunds.value,
                item.refunds_number.value,
                item.discounts.value,
                item.total_cogs.value,
                item.avg_order_size.value,
                item.avg_order_value.value,
                item.void_number.value,
                item.void.value,
              ],
      };
      salesByStoreInsights["data"]["values"].push(value);
    });

    salesByStoreInsights["data"]["values"].sort(function (a, b) {
      return b.net_sales_original - a.net_sales_original;
    });

    const basketSize = {
      header: "BASKET SIZE",
      data: {
        values: [
          {
            category: { value: avg_order_size.header },
            amt_cur: { value: avg_order_size.value },
          },
          {
            category: { value: avg_order_value.header },
            amt_cur: { value: avg_order_value.value },
            currency: this.props.currency,
          },
          // {
          //   category: { value: top_basket_category.header },
          //   amt_cur: { value: top_basket_category.value }
          // }
        ],
      },
    };
    net_sales.header = "Total Revenue";

    console.log(
      "this.props.filters.selectedDate",
      this.props.filters.selectedDate
    );

    return (
      <div>
        <div>
          <Grid.Row style={{ float: "right" }}>
            <Grid.Column>
              <MultiSelect />
            </Grid.Column>
            <Grid.Column>
              <div style={styles.datePicker}>
                <DatePicker />
              </div>
            </Grid.Column>
          </Grid.Row>
        </div>

        <div style={{ clear: "both" }}>
          <Header style={styles.mainHeadig} as="h3">
            SUMMARY
          </Header>
          <Grid columns={4}>
            <Box
              currency={currency}
              componentData={net_sales}
              totalRevenueSubtitle={true}
              totalOnline={totalOnline}
              user_type={auth.filters && auth.filters.user_type}
            />
            <Box currency={currency} componentData={gross_margin_value} />
            <Box componentData={total_orders} />
            {auth.filters && auth.filters.user_type === "shell_head_office" ? (
              <Grid.Column verticalAlign="middle">
                <div style={styles.boxMain}>
                  <Grid.Row style={styles.heading}>
                    <Header as="h5" style={styles.headingText}>
                      Basket Size
                    </Header>
                  </Grid.Row>
                  <Grid.Row>
                    <Grid.Column
                      style={{ ...styles.headingText, width: "100%" }}
                    >
                      {/* <div style={{ fontSize: "14px" }}>
                      {basketSize.data.values[1].category.value}
                    </div> */}
                      <div style={{ ...styles.textValue }}>
                        {displayValue(
                          basketSize.data.values[1].amt_cur.value,
                          basketSize.data.values[1].currency
                        )}
                      </div>
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row>
                    <span style={{ ...styles.comparision, width: "100%" }}>
                      {basketSize.data.values[0].category.value}:{" "}
                      {displayValue(
                        basketSize.data.values[0].amt_cur.value,
                        basketSize.data.values[0].currency
                      )}
                    </span>
                  </Grid.Row>
                </div>
              </Grid.Column>
            ) : (
              <Box componentData={totalOnline} />
            )}
          </Grid>
          <Grid>
            <Grid.Row>
              <Grid.Column width={12}>
                <div
                  style={{ height: "100%", width: "100%", paddingLeft: "2em" }}
                >
                  <Chart title="SALES BY STORE" data={salesByStore} />
                </div>
              </Grid.Column>
              <Grid.Column width={4}>
                <Chart title="SALES BY CATEGORY" data={salesByCategory} />
              </Grid.Column>
            </Grid.Row>
          </Grid>
          <Grid columns={2}>
            {/* <ListData componentData={basketSize} itemCount={3} /> */}
          </Grid>
          <Grid columns={3}>
            <Chart title="SALES BY DAY" data={salesbyDay} />
            <Chart title="SALES BY HOUR" data={salesbyHour} />
            <ListSalesData
              percentage="%"
              componentData={salesByStoreInsights}
              itemCount={6}
              user_type={(auth.filters && auth.filters.user_type) || ""}
              selected_dates={this.props.filters.selectedDate || ""}
            />
          </Grid>
          <Grid columns={2}>
            <TableData currency={currency} componentData={sales_by_category} />
            <TableData
              currency={currency}
              componentData={sales_by_sub_category}
            />
          </Grid>
          <Grid columns={2}>
            <TableData currency={currency} componentData={top_items_by_sales} />
            <TableData
              currency={currency}
              componentData={lowest_items_by_sales}
            />
          </Grid>
        </div>
      </div>
    );
  }
}

const styles = {
  comparision: {
    fontFamily: "Roboto",
    color: "#666874",
    fontWeight: 300,
    fontSize: 10,
    marginTop: 5,
  },
  heading: {
    flex: 0,
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    paddingBottom: 5,
  },
  boxMain: {
    minHeight: 170,
    marginBottom: 30,
    marginTop: 15,
    paddingBottom: 20,
    paddingTop: 35,
    backgroundColor: "#ffffff",
    borderRadius: 5,
    textAlign: "center",
    boxShadow: "0 1px 6px rgba(0, 0, 0, 0.1)",
  },
  headingText: {
    fontSize: 16,
    fontFamily: "Roboto",
    color: "#666874",
    fontWeight: 300,
    marginBottom: 8,
  },
  textValue: {
    fontSize: 32,
    fontWeight: 400,
    flex: 0,
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    alignSelf: "center",
    fontFamily: "Roboto",
    color: "#313131",
  },
  dropDown: {
    fontFamily: "Roboto",
    borderRadius: 20,
    color: "rgb(102, 104, 116)",
    marginRight: 50,
    position: "relative",
    top: 52,
    backgroundColor: "transparent",
    fontSize: 14,
    fontWeight: 300,
  },
  customClass: {
    backgroundColor: "transparent",
    color: "rgb(102, 104, 116)",
    fontSize: 14,
    fontWeight: 300,
  },
  topHeader: {
    backgroundColor: "#652d92",
    color: "white",
  },
  mainHeadig: {
    marginTop: 30,
    fontWeight: 400,
    fontFamily: "Roboto",
    color: "#666874",
  },
  title: {
    padding: 10,
    fontSize: 22,
  },
  sideBar: {
    top: 45,
    backgroundColor: "#2c2435",
  },
  datePicker: {
    paddingTop: 20,
    paddingRight: 20,
    fontFamily: "Roboto",
    color: "#666874",
    fontWeight: 400,
  },
};

const mapStateToProps = (state) => {
  // console.log("state : ", state);
  return {
    ...getSelectorAnalytics(state),
    auth: getSelectorAuth(state),
    currency: state.auth ? state.auth.currency : "",
  };
};

export default connect(mapStateToProps, { loadInitialAnalyticsState })(Home);



// WEBPACK FOOTER //
// ./src/containers/Home/index.js